<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="File Resume">
            <common-training-header/>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col :flex="5">
                <a-card>
                    <strong>Kelas: </strong>
                    <a-form-item>
                        <a-select
                            v-model="selected"
                            style="width: 200px" @change="handleChange">
                            <a-select-option
                                v-for="d in classes"
                                :key="d.id"
                                :value="d.id"
                            >
                                {{ d.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                </a-card>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :rowClassName="(r) => r.is_heading ? 'row-heading' : null"
                bordered
                >

                <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                    <template slot-scope="record" v-if="! record.is_heading">
                        {{ record.inspirator }}
                    </template>
                </a-table-column>

                <a-table-column key="status" title="Status" className="align-center align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <div v-show="moment().diff(moment(record.time_end, 'YYYY-MM-DD HH:mm:ss'), 'minutes') > 0 && isShow(record.status) == true">
                            <a-tag
                                v-if="record.status > 0"
                                :color="colorLevel(record.status)"
                            >
                                Validasi Level {{ roleLevel(record.status) }}
                            </a-tag>
                            <a-tag color="red" v-else>
                                belum divalidasi
                            </a-tag>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-left">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <a-button
                            v-show="record.session_id != null && moment().diff(moment(record.time_end, 'YYYY-MM-DD HH:mm:ss'), 'minutes') > 0
                            && isShow(record.status) == true"
                            type="primary"
                            size="small"
                            @click="class_resume(record.session_id, record.class_id)"
                            block
                        >
                            View Detail
                        </a-button>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>
    </div>
</template>

<script>
const materi = {
    id: null,
    name: null,
    inspirator: null,
    is_heading: false,
    status: null,
    material_id: null,
    session_id: null,
    training_modul_class_id: null,
    time_end: null
}

export default {
    created() {
        this.getClasses();
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            items: {
                materials: {
                    categories: [
                        {
                            materials: []
                        }
                    ]
                }
            },
            data: {
                
            },
            classes: [],
            selected: null
        };
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        currentRoute(){
            return this.$laravel.current_route
        },
        tableData() {
            let collection = [], id = 0

            this.items.materials.categories.forEach(function (item, index) {
                collection.push(Object.assign(Object.create(materi), {
                    id: id,
                    name: item.name,
                    inspirator: null,
                    is_heading: true,
                    status: null,
                    material_id: null,
                    session_id: null,
                    training_modul_class_id: null,
                    time_end: null
                }))
                
                id++

                item.materials.forEach(function (item, index) {
                    collection.push(Object.assign(Object.create(materi), {
                        id: id,
                        name: item.name,
                        inspirator: item.sessions[0].inspirator.name,
                        is_heading: false,
                        status: item.sessions[0].resume_verification_level,
                        material_id: item.id,
                        session_id: item.sessions[0].id,
                        class_id: item.sessions[0].class_id,
                        time_end: item.sessions[0].session_time_end,
                    }))
                    id++
                })
            })

            return collection
        },
    },
    methods: {
        getItems(id) {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-resume.materials"), {
                    params: {
                        class: id
                    }
                })
                .then(response => {
                  this.items = response.data
                  })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        getClasses() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.training-classes"))
                .then(response => {
                  this.classes = response.data.classess
                  this.getItems(this.classes[0].id);
                  })
                .catch(error => this.handleXhrError(error));
        },
        download(url) {
            window.open(url, '_blank')
        },
        handleChange(value) {
            this.getItems(value)
            this.selected = value
        },
        class_resume(session, class_id){
            let params = {
                session: session,
                class: class_id,
                previous: this.currentRoute
            }
            
            window.location.href = this.routeUri('admin.classical.class.resume') + '?' + this.$qs.stringify(params)
        },
        colorLevel(resumeVerifyLevel){
            if(resumeVerifyLevel > 2)
                return 'green'

            return 'orange'
        },
        roleLevel(level){
            switch (level) {
                case 1:
                    return "1 - PM BK"
                case 2:
                    return "2 - Inspirator"
                case 3:
                    return "3 - PM BK"
            }
        },
        isShow(status){
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            role = typeof role === "string" ? role : role[0]

            switch(role){
                case "project-manager":
                    return true
                case "inspirator":
                    if(status == 0)
                        return false
                    return true
                case "admin":
                    return true
                default:
                    return false
            }
        }
    },
    watch: {
        classes: function(value) {
            this.selected = value[0].id
        }
    }
};
</script>


